import {
	type PreferencesCookiesCategories,
	PreferencesCookiesCategoriesValue,
} from 'cookies/types'

const getCategorieStatus = (
	status: PreferencesCookiesCategoriesValue,
	newStatus: PreferencesCookiesCategoriesValue
): PreferencesCookiesCategoriesValue =>
	status === PreferencesCookiesCategoriesValue.disabled
		? PreferencesCookiesCategoriesValue.disabled
		: newStatus

export const getCategoriesStatus = (
	categories: PreferencesCookiesCategories,
	status: PreferencesCookiesCategoriesValue
): PreferencesCookiesCategories => {
	const updatedCategories = {} as PreferencesCookiesCategories

	for (const categorie of Object.keys(categories) as Array<
		keyof PreferencesCookiesCategories
	>) {
		const value = categories[categorie]
		updatedCategories[categorie] = getCategorieStatus(value, status)
	}

	return updatedCategories
}
